/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class MCHRoot extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
};
export default MCHRoot;



// WEBPACK FOOTER //
// ./src/mall/mallHome/root.js